import { useContext, useState, useRef } from 'react';
import './createAd.css';
import axiosConn from '../../axiosConn';
import { useConfettiText } from '../../hooks/useConfettiText';
import { useMediaQuery } from 'react-responsive';

import { AuthContext } from '../../context/AuthContext';
import { CircularProgress } from '@material-ui/core';
import { useTheme } from '../../context/ThemeContext';

// import IconButton from 'material-ui/lib/icon-button';
//import { Icon_Visa, Icon_MasterCard } from 'material-ui-credit-card-icons';
const AD_PARTICLE_COUNT = 1000;

export default function CreateAd() {
  const { player } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [adUrl, setAdUrl] = useState('');
  const [adImgUrl, setAdImgUrl] = useState('');
  const [adTitle, setAdTitle] = useState('');
  const inputRef = useRef(null);
  const price = 9.99;
  const mobileView = useMediaQuery({
    query: '(max-width: 805px)',
  });
  const { darkTheme } = useTheme();

  const [showConfettiText, ConfettiTextComponent] = useConfettiText(
    inputRef, // inputRef
    mobileView, // mobileView
    '+10 JGK Yay!', // customText
    AD_PARTICLE_COUNT, // particleCount
    'CreateAd', // parent
    false, // isVoiceMemo
  );

  const submitHandler = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    setError('');
    setIsLoading(true);

    try {
      const Ad = {
        url: adUrl.trim(),
        img: adImgUrl.trim(),
        title: adTitle.trim(),
        playerId: player.data.player.playerId,
        price,
      };
      const res = await axiosConn.post('ads', Ad, {
        headers: {
          Authorization: `Bearer ${player.token}`,
        },
      });
      const res2 = await axiosConn.get(
        `adBookings/checkout-session/${res.data.data.data._id}`,
        {
          headers: {
            Authorization: `Bearer ${player.token}`,
          },
        },
      );
      showConfettiText();
      window.location.href = res2.data.session.url;
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          'Could not start Stripe checkout. Please try again.',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="createAdFeed">
      <div className="createAdFeedWrapper">
        <div className={darkTheme ? 'createAdShareDarkTheme' : 'createAdShare'}>
          <div className="createAdShareInner">
            <div className="createAdTop">
              <img
                className="shareProfileImgCreateAd"
                src={
                  player.data.player.profilePhoto
                    ? player.data.player.profilePhoto
                    : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                }
                alt=""
              />
              <div
                className={
                  darkTheme ? 'createAdDesc dark-theme' : 'createAdDesc'
                }
              >
                <div className="createAdDescTitle">
                  Reach local players on JoeGalaxy
                </div>
                <div className="createAdDescSub">
                  USD $9.99 per month. Create your ad now, then complete secure
                  Stripe checkout.
                </div>
                <div className="createAdSecurityPill">
                  <span>Payments secured by</span>
                  <strong>Stripe</strong>
                </div>
              </div>
              <form
                className={
                  darkTheme ? 'createAdBox dark-theme' : 'createAdBox'
                }
                onSubmit={submitHandler}
              >
                <div className="createAdField">
                  <label className="createAdFieldLabel">Destination URL</label>
                  <div className="createAdInputShell">
                    <span className="createAdInputTag">URL</span>
                    <input
                      placeholder="https://your-site.com"
                      type="url"
                      required
                      className="createAdFieldInput"
                      value={adUrl}
                      onChange={(e) => setAdUrl(e.target.value)}
                      disabled={isLoading}
                      autoComplete="url"
                    />
                  </div>
                </div>
                <div className="createAdField">
                  <label className="createAdFieldLabel">Creative image URL</label>
                  <div className="createAdInputShell">
                    <span className="createAdInputTag">IMG</span>
                    <input
                      placeholder="https://image-host.com/ad.jpg"
                      type="url"
                      required
                      className="createAdFieldInput"
                      value={adImgUrl}
                      onChange={(e) => setAdImgUrl(e.target.value)}
                      disabled={isLoading}
                      autoComplete="url"
                    />
                  </div>
                </div>
                <div className="createAdField">
                  <label className="createAdFieldLabel">Ad headline</label>
                  <div className="createAdInputShell">
                    <span className="createAdInputTag">TXT</span>
                    <input
                      placeholder="Ad title"
                      type="text"
                      required
                      className="createAdFieldInput"
                      value={adTitle}
                      onChange={(e) => setAdTitle(e.target.value)}
                      disabled={isLoading}
                      maxLength={100}
                    />
                  </div>
                </div>
                <div className="createAdHint">
                  Step 1: Save ad details. Step 2: complete Stripe checkout to
                  activate.
                </div>
                {error ? <div className="createAdError">{error}</div> : null}
                <div className="createAdActions">
                  <ConfettiTextComponent />
                  <button
                    ref={inputRef}
                    className="payButton"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <CircularProgress color="inherit" size="20px" />
                    ) : (
                      'Continue to Stripe'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
